import React from 'react';
import { flow } from 'lodash';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import { useDispatch } from 'react-redux';

import toaster from '@giro/shared-store/toaster';

import useFetchHook from '@giro-pdv/hooks/useFetch.hook';

import deleteApiTerminalsRegistrationsIdService from '@giro/shared-services/pdv/deleteApiTerminalsRegistrationsId.service';

const DialogDeleteTerminalComponent = ({
  open,
  registration,
  onClose,
  onDeleted,
}: {
  open: boolean;
  registration: { id: any; alias?: string | null } | null;
  onClose: () => void;
  onDeleted: () => void;
}) => {
  const dispatch = useDispatch();

  const showToaster = flow(toaster.action.show, dispatch);

  const deleteFetch = useFetchHook(deleteApiTerminalsRegistrationsIdService, {
    requestOnMount: false,
  });

  const deleting = deleteFetch.loading;

  const handleConfirm = async () => {
    if (deleting) return;

    const [success] = await deleteFetch.handleFetch(registration?.id);

    if (!success) {
      showToaster({
        message: 'Não foi possível excluir o terminal.',
        variant: 'error',
      });
      return;
    }

    showToaster({
      message: 'Terminal excluído com sucesso.',
      variant: 'success',
    });
    onDeleted();
    onClose();
  };

  const name = registration?.alias || `#${registration?.id ?? ''}`;

  return (
    <Dialog
      open={open}
      onClose={deleting ? undefined : onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Excluir terminal</DialogTitle>
      <DialogContent>
        <Typography variant="trasso_body_small" color="trasso.purple.100">
          Tem certeza que deseja excluir o terminal <strong>{name}</strong>?
          Esta ação cancela o terminal no provedor e desvincula o dispositivo. O
          aparelho precisará ser credenciado novamente para voltar a
          transacionar.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={deleting}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleConfirm}
          disabled={deleting}
          startIcon={deleting ? <CircularProgress size={16} /> : undefined}
        >
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogDeleteTerminalComponent;
